import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import scheduledIllustration from "../../../static/assets/Environmental audit-rafiki.svg";

const formatCampaignStartDate = (start) => {
  if (!start) {
    return "";
  }

  const date = new Date(start);
  const language = i18n.language || navigator.language;

  let formatted = date.toLocaleDateString(language, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  formatted = formatted.replace(/^\w/, (char) => char.toUpperCase());
  formatted = formatted
    .replace(/\bde\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

  return formatted;
};

const CampaignScheduledEmptyState = ({ campaignPeriod, className = "" }) => {
  const { t } = useTranslation();

  const startDateLabel = useMemo(
    () => formatCampaignStartDate(campaignPeriod?.start),
    [campaignPeriod?.start],
  );

  return (
    <div className={`campaign-scheduled-empty-state ${className}`.trim()}>
      <div className="campaign-scheduled-empty-state__panel">
        <div className="campaign-scheduled-empty-state__content">
          <div className="campaign-scheduled-empty-state__illustration">
            <img
              src={scheduledIllustration}
              alt=""
              className="campaign-scheduled-empty-state__illustration-image"
            />
          </div>
          <p className="campaign-scheduled-empty-state__title">
            {t("campaign.scheduledEmptyTitle")}
          </p>
          <p className="campaign-scheduled-empty-state__line">
            {t("campaign.scheduledEmptyStartLine", {
              startDate: startDateLabel,
            })}
          </p>
          <p className="campaign-scheduled-empty-state__line">
            {t("campaign.scheduledEmptyHint")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CampaignScheduledEmptyState;
